import { IonButton, IonInput } from "@ionic/react";
import { forwardRef, useRef } from "react";
import { useTranslation } from "react-i18next";
import { type FieldApi } from "@tanstack/react-form";
import { getErrorText } from "@/components/atoms/form-ion/utils";
import { cn } from "@/lib/style/cva.config";

export type CustomFieldFileProps = {
  label: string;
  description?: string;
  required?: boolean;
  accept?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: FieldApi<
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any
  >;
};

export const CustomFieldFile = forwardRef<
  HTMLIonInputElement,
  React.ComponentProps<typeof IonInput> & CustomFieldFileProps
>(function CustomFieldFile({ label, description, required = false, accept, field, ...props }, ref) {
  const { t, i18n } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    field.handleChange(file);
  };

  const getDisplayValue = () => {
    if (field.state.value instanceof File) {
      return field.state.value.name;
    }
    if (typeof field.state.value === "string" && field.state.value) {
      // Extract filename from URL
      return field.state.value.split("/").pop() || field.state.value;
    }
    return "";
  };

  return (
    <div className="flex flex-col gap-2">
      <IonInput
        ref={ref}
        name={field.name}
        value={getDisplayValue()}
        readonly
        onClick={handleFileSelect}
        onIonBlur={field.handleBlur}
        errorText={getErrorText({ language: i18n.language, errors: field.state.meta.errors })}
        {...props}
        labelPlacement={props.labelPlacement ?? "stacked"}
        label={label}
        helperText={description}
        className={cn(
          required && "ion-required",
          field.state.meta.isTouched && "ion-touched",
          !!field.state.meta.errors && field.state.meta.errors.length > 0 && "ion-invalid",
          "cursor-pointer",
          props.className,
        )}
      />
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        onChange={handleFileChange}
        className="hidden"
      />
      {/* {field.state.value && typeof field.state.value === "string" && (
        <IonButton
          size="small"
          fill="outline"
          href={field.state.value}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("common:view-file")}
        </IonButton>
      )} */}
    </div>
  );
});
